import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

function TemplatePreview({
  template,
  selected = false,
  onSelect
}) {
  const { t } = useTranslation('ecommerce')

  const handleSelect = () => {
    if (onSelect) {
      onSelect(template.id)
    }
  }

  return (
    <button
      type="button"
      onClick={handleSelect}
      aria-label={template.name}
      className={`
        relative flex flex-col rounded-lg overflow-hidden border-2 transition-all
        hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
        ${selected ? 'ring-2 ring-blue-500 border-blue-500' : 'border-gray-200 hover:border-gray-300'}
      `}
    >
      {/* Thumbnail */}
      <div className="aspect-[9/16] w-full bg-gray-100 overflow-hidden">
        <img
          src={template.thumbnail}
          alt={template.name}
          className="w-full h-full object-cover"
        />
      </div>

      {/* Content */}
      <div className="p-3 text-left">
        <h3 className="font-medium text-gray-900 text-sm mb-1">
          {template.name}
        </h3>
        <p className="text-xs text-gray-500 mb-2 line-clamp-2">
          {template.description}
        </p>

        {/* Best-for tags */}
        {template.bestFor && template.bestFor.length > 0 && (
          <div className="flex flex-wrap gap-1">
            {template.bestFor.map((tag) => (
              <span
                key={tag}
                className="inline-block px-2 py-0.5 bg-gray-100 text-gray-600 text-xs rounded-full"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>

      {/* Selected indicator */}
      {selected && (
        <div className="absolute top-2 right-2 bg-blue-500 text-white rounded-full p-1">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
      )}
    </button>
  )
}

TemplatePreview.propTypes = {
  template: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    thumbnail: PropTypes.string.isRequired,
    bestFor: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  selected: PropTypes.bool,
  onSelect: PropTypes.func,
}

export default TemplatePreview
